import {Head} from "@/layout/Head.tsx";
// import {
//     Breadcrumb,
//     BreadcrumbItem,
//     BreadcrumbLink,
//     BreadcrumbList,
//     BreadcrumbPage,
//     BreadcrumbSeparator,
// } from "@/components/ui/breadcrumb"
import {MagnifyingGlassIcon} from "@heroicons/react/24/outline";
import { useGetExtensionQuery, useGetExtensionsInfiniteQuery} from "@/store/extensions.ts";
import {ExtensionCard} from "@/pages/extensions/components/extension-card.tsx";
import {useCurrentSystem} from "@/hooks/useCurrentSystem.tsx";
import {System} from "@/types/Systems.ts";
import {ProviderExtensionEdit} from "@/pages/extensions/components/ProviderExtensionEdit.tsx";
import {EditDrawer} from "@/pages/extensions/components/EditDrawer.tsx";
import {Wrapper} from "@/pages/extensions/components/wrapper.tsx";
import {useRefInfinity} from "@/hooks/useRefInfinty.ts";
import {Spinner} from "@/components/ui/spinner.tsx";
import {Input} from "@/components/ui/input.tsx";
import {MultiSelect, Option} from "@/components/multi-select.tsx";
import {useEffect, useState} from "react";
import {useGetExtensionsTypes} from "@/hooks/useExtensionsTypes.ts";
import {cn} from "@/lib/utils.ts";
import {GlobalActionsTool} from "@/pages/extensions/components/GlobalActionsTool.tsx";
import {PageHeader} from "@/layout/components/PageHeader.tsx";

export function Extensions() {

    const {system} = useCurrentSystem();

    const {data: extension} = useGetExtensionQuery((system as System)?.main_menu_id, {
        skip: !system
    });

    const extensionTypes = useGetExtensionsTypes(t => t.priority < 100);

    const [stateQuery, setStateQuery] = useState<{
        search: string;
        types: Option[]
    }>({
        search: '',
        types: []
    });

    const [paramsQuery, setParamsQuery] = useState<{
        search: string;
        types: string[]
    }>({
        search: '',
        types: []
    });

    useEffect(() => {
        const timer = setTimeout(() => {
            setParamsQuery(prev => ({
                search: stateQuery.search,
                types: stateQuery.types.map(t => t.value)
            }));
        }, 1000 );

        return () => {
            clearTimeout(timer);
        }
    }, [stateQuery]);

    const {data: subExtensions, isFetching, fetchNextPage} = useGetExtensionsInfiniteQuery({
        ...(paramsQuery.search.length ? {} : {parent: extension?.id}),
        ...paramsQuery
    }, {
        skip: !extension
    });

    const refInfinity = useRefInfinity(fetchNextPage, subExtensions);

    if(!extension) {
        return null;
    }

    return (
        <ProviderExtensionEdit>
            <Wrapper>
                <PageHeader title="שלוחות"/>
                <div className="flex items-center justify-between">
                    <div className="w-1/3 relative">
                        <Input
                            value={stateQuery.search}
                            onChange={(e) => setStateQuery((prev) => ({...prev, search: e.target.value}))}
                            className="bg-white pe-8"
                            placeholder="חיפוש שלוחה לפי שם או מספר"
                        />
                        <MagnifyingGlassIcon className="size-5 absolute top-1/2 transform -translate-y-1/2 end-2 text-gray-400"/>
                    </div>

                    <div>
                        <div className="w-72">
                            <MultiSelect
                                popoverClassName="w-72"
                                options={extensionTypes ? extensionTypes.map<Option>(e => ({label: e.name, value: e.value})) : []}
                                placeholder="סינון לפי סוג שלוחה"
                                onChange={(types) => setStateQuery((prev) => ({...prev, types}))}
                                selected={stateQuery.types}
                            />
                        </div>
                    </div>
                </div>

                <div className={cn("space-y-5 transition duration-500", isFetching && 'opacity-50')}>
                    {paramsQuery.search.length < 1 &&  <ExtensionCard isMain {...extension}/>}

                    <div className="ps-8 space-y-5">
                        {subExtensions?.pages.map(p => p.results?.map((extension) => (
                            <ExtensionCard key={extension.id} {...extension}/>
                        )))}
                    </div>

                    <div ref={refInfinity} className="flex justify-center items-center">
                        {isFetching && (
                            <span className="px-4 flex justify-center items-center">
                                <Spinner />
                            </span>
                        )}
                    </div>
                </div>

                <EditDrawer/>

                <GlobalActionsTool/>
            </Wrapper>
        </ProviderExtensionEdit>
    )
}